import authReducer from "./authReducer";
import jobReducer from "./jobReducer";
import { combineReducers } from "redux";

const rootReducer = combineReducers({
  auth: authReducer,
  project: jobReducer
});
export default rootReducer;
